/* eslint-disable */
import {
  deleteInstance,
  getInstance,
  updateInstance,
  addInstance,
  patchInstance,
} from './instacnes'

const withScreenIdHeader = (screenId) => (screenId ? { headers: { 'screen-id': screenId } } : {})

export const updateWithParams = async (route, query, data, screenId) => {
  try {
    let response = await updateInstance.request(`${route}?${query}`, {
      ...withScreenIdHeader(screenId),
      data,
    })
    return response
  } catch (e) {
    if (e.response && e.response.data) {
      return e.response.data
    }
    throw new Error(e.message)
  }
}

//get service id from component to fecth row from api and delete it
export const deleteData = async (route, id, qv = 'id', screenId) => {
  try {
    let response = await deleteInstance.request(
      `${route}?${qv}=${id}`,
      withScreenIdHeader(screenId),
    )
    return response.data
  } catch (e) {
    if (e.response && e.response.data) {
      return e.response.data
    }
    throw new Error(e)
  }
}
export const deleteWithParams = async (route, query, screenId) => {
  try {
    let response = await deleteInstance.request(`${route}?${query}`, withScreenIdHeader(screenId))
    return response.data
  } catch (e) {
    if (e.response && e.response.data) {
      return e.response.data
    }
    throw new Error(e.message)
  }
}
//get data from component and fetch it in api
export const addData = async (route, data, screenId, options = {}) => {
  try {
    let response = await addInstance.request(route, {
      ...withScreenIdHeader(screenId),
      ...(options.skipLoading ? { skipLoading: true } : {}),
      ...(options.timeout ? { timeout: options.timeout } : {}),
      data,
    })
    return response
  } catch (e) {
    if (options.throwHttpErrors) {
      const status = e.response?.status
      const body = e.response?.data
      const apiMessage =
        (body &&
          typeof body === 'object' &&
          (body.Error?.message || body.data?.message || body.message)) ||
        null
      const err = new Error(apiMessage || e.message || 'Request failed')
      err.status = status
      err.code = e.code
      err.body = body
      throw err
    }
    if (e.response && e.response.data) {
      return e.response.data
    }
    throw new Error(e.message)
  }
}
export const addDataWithoutBody = async (route, screenId) => {
  try {
    let response = await addInstance.request(route, withScreenIdHeader(screenId))
    return response
  } catch (e) {
    if (e.response && e.response.data) {
      return e.response.data
    }
    throw new Error(e.message)
  }
}
export const postData = async (route, query, screenId) => {
  try {
    const path = query ? `${route}?${query}` : route
    let response = await addInstance.request(path, withScreenIdHeader(screenId))
    return response.data
  } catch (e) {
    if (e.response && e.response.data) {
      return e.response.data
    }
    throw new Error(e.message)
  }
}

export const patchData = async (route, query, screenId) => {
  try {
    let url = route
    let params

    if (query) {
      const combined = String(route).includes('?') ? `${route}&${query}` : `${route}?${query}`
      const [path, queryString] = combined.split('?')
      url = path
      params = Object.fromEntries(new URLSearchParams(queryString))
    } else if (String(route).includes('?')) {
      const [path, queryString] = String(route).split('?')
      url = path
      params = Object.fromEntries(new URLSearchParams(queryString))
    }

    let response = await patchInstance.request(url, {
      ...withScreenIdHeader(screenId),
      ...(params ? { params } : {}),
    })
    return response.data
  } catch (e) {
    if (e.response && e.response.data) {
      return e.response.data
    }
    throw new Error(e.message)
  }
}

export const patchDataUsingBody = async (route, data, screenId, options = {}) => {
  try {
    let response = await patchInstance.request(route, {
      ...withScreenIdHeader(screenId),
      ...(options.skipLoading ? { skipLoading: true } : {}),
      data,
    })
    return response.data
  } catch (e) {
    if (e.response && e.response.data) {
      return e.response.data
    }
    throw new Error(e.message)
  }
}

//get id from component to fecth row from api and return it to component
export const selectDataByParam = async (route, query, screenId) => {
  try {
    let response = await getInstance.request(`${route}?${query}`, withScreenIdHeader(screenId))
    return response.data
  } catch (e) {
    if (e.response && e.response.data) {
      return e.response.data
    }
    throw new Error(e.message)
  }
}

//get service id from component to fecth row from api and return it to component
export const selectDataById = async (route, id, queryVar = 'id', screenId) => {
  try {
    let response = await getInstance.request(
      `${route}?${queryVar}=${id}`,
      withScreenIdHeader(screenId),
    )
    return response.data
  } catch (e) {
    if (e.response && e.response.data) {
      return e.response.data
    }
    throw new Error(e.message)
  }
}

//get all services from api and return it to component
export const getData = async (route, screenId, options = {}) => {
  try {
    let url = route
    let params = options.params ? { ...options.params } : undefined

    if (route.includes('?')) {
      const [path, queryString] = route.split('?')
      url = path
      const queryParams = Object.fromEntries(new URLSearchParams(queryString))
      params = { ...queryParams, ...(params || {}) }
    }

    let response = await getInstance.request(url, {
      ...withScreenIdHeader(screenId),
      ...(options.skipLoading ? { skipLoading: true } : {}),
      ...(options.timeout ? { timeout: options.timeout } : {}),
      ...(params ? { params } : {}),
    })
    return response.data
  } catch (e) {
    if (e.response && e.response.data) {
      return e.response.data
    }
    throw new Error(e.message)
  }
}

//get service id and new data from component then fetch row based service id then update row data
export const updateData = async (route, id, data, qv = 'id', screenId, options = {}) => {
  try {
    let response = await updateInstance.request(`${route}?${qv}=${id}`, {
      ...withScreenIdHeader(screenId),
      ...(options.skipLoading ? { skipLoading: true } : {}),
      data,
    })
    return response
  } catch (e) {
    if (e.response && e.response.data) {
      return e.response.data
    }
    throw new Error(e.message)
  }
}

export const updateDataWithoutId = async (route, data, screenId, options = {}) => {
  try {
    let response = await updateInstance.request(`${route}`, {
      ...withScreenIdHeader(screenId),
      ...(options.skipLoading ? { skipLoading: true } : {}),
      ...(options.timeout ? { timeout: options.timeout } : {}),
      data,
    })
    return response
  } catch (e) {
    if (e.response && e.response.data) {
      return e.response.data
    }
    throw new Error(e.message)
  }
}
